import { createRouter, createWebHistory, type RouteLocationNormalizedLoaded, type RouteRecordRaw } from 'vue-router'

const defaultThemeColor = '#fafbff'
const themeMetaName = 'theme-color'

function syncThemeColor(color?: string) {
  // 按页面主色同步浏览器主题色，降低手机端顶部栏与内容区的割裂感。
  if (typeof document === 'undefined') return

  const meta = document.querySelector(`meta[name="${themeMetaName}"]`)
  if (!meta) return

  meta.setAttribute('content', color ?? defaultThemeColor)
}

export function syncThemeColorByRoute(route: RouteLocationNormalizedLoaded) {
  syncThemeColor(typeof route.meta.themeColor === 'string' ? route.meta.themeColor : undefined)
}

const routes: RouteRecordRaw[] = [
  // 首页：语言选择（点 logo / 顶部 brand 也回这里）
  {
    path: '/',
    name: 'language-select',
    component: () => import('@/views/LanguageSelect.vue'),
    meta: {
      themeColor: '#edf8ff',
    },
  },
  {
    path: '/assistant',
    name: 'assistant',
    component: () => import('@/views/VoiceAssistant.vue'),
    meta: {
      themeColor: '#f5f9ff',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach(to => {
  syncThemeColorByRoute(to)
})
